export enum QuestionMarkupItem {
    Label = 'label',
    Comment = 'comment',
    Image = 'image',
    Control = 'control',
}

export interface QuestionMarkupProps {
    label?: React.ReactNode;
    comment?: React.ReactNode;
    image?: React.ReactNode;
    control?: React.ReactNode;
    positions?: QuestionMarkupItem[];
}
